/** Booking page for a demo call with Marc, Scalar's CEO; the dialog embeds it and links here as the fallback */
export const DEMO_CALL_URL = 'https://scalar.cal.com/marc/30min'

/** Opens a direct message to Marc on X */
export const MARC_X_DM_URL = 'https://x.com/messages/compose?recipient_id=321010445'
